/**
 * 积分明细接口
 */
export default {
    BASE_URL: '/crm/integral',
    api: [
        {
            name: 'getCompanyPointList',
            desc: '获取企业积分明细列表',
            method: 'GET',
            path: '/detail/org'
        },
        {
            name: 'getPersonalPointList',
            desc: '获取个人积分明细列表',
            method: 'GET',
            path: '/detail/member'
        },
        {
            name: 'pointActionType',
            desc: '获取积分变更明',
            method: 'GET',
            path: '/actionType'
        }
    ]
}
  


// WEBPACK FOOTER //
// ./src/api/apis/integral/detail.js